module.exports = __webpack_public_path__ + "static/img/gls_cover.33b63e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testImg/gls_cover.jpg
// module id = qHwt
// module chunks = 1